import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, LINK_SEVERITY } from '@tmapy/style-guide';
const createLink = (href) => (text) => (_jsx(Link, { href: href, severity: LINK_SEVERITY.COLORFUL, isExternal: true, target: '_blank', children: text }));
export const FormattedHtmlMessage = React.memo(({ id, defaultMessage, description, links, values, children }) => {
    const linkComponents = {};
    if (links) {
        for (const [name, config] of Object.entries(links)) {
            const linkName = `LINK-${name}`;
            switch (typeof config) {
                case 'string': {
                    linkComponents[linkName] = createLink(config);
                    break;
                }
                case 'object': {
                    linkComponents[linkName] = config.image
                        ? (text) => {
                            const imageTitle = typeof text?.[0] === 'string' ? text[0] : '';
                            return (_jsx("a", { href: config.href, rel: 'noreferrer', target: '_blank', children: _jsx("img", { src: config.image, alt: imageTitle, title: imageTitle }) }));
                        }
                        : createLink(config.href);
                    break;
                }
            }
        }
    }
    return (_jsx(FormattedMessage, { id: id, defaultMessage: defaultMessage, description: description, values: {
            ...linkComponents,
            ...values,
        }, children: children }));
});
//# sourceMappingURL=FormattedHtmlMessage.js.map